import loginModel from '../../../../models/login.model';
import ViewBase from '../../../view-base.view';
import { staticUrls } from '../../../../config/constants';

export default function UserProfileView() {
    ViewBase.call(this);
    let profile = null;

    return {
        view: (vnode) => {
            profile = loginModel.profileDetails;
            return [
                profile &&
                m('.row',
                    m('.col-md-12',
                        m('.d-flex',
                            m('.flex-grow-1',
                                m('h1.mb-3', this.getText("LT00000187", "User Profile"))
                            )
                        ),
                        m('.card',
                            m('.card-body.py-3',
                                m('.row',
                                    m('.col-md-3',
                                        m('img.mw-100.mh-100', {
                                            src: profile.photoString ? profile.photoString : staticUrls.emptyUserImage
                                        })
                                    ),
                                    m('.col-md-6',
                                        m('.row',
                                            m('.form-group.row',
                                                m('label.col-md-4.col-form-label', this.getText("LT00000049", "User ID")),
                                                m('.col-md-6', m('label.col-form-label', profile.userID)),
                                            )
                                        ),
                                        m('hr.hr-no-style'),
                                        m('.row',
                                            m('.form-group.row',
                                                m('label.col-md-4.col-form-label', this.getText("LT00000050", "User Name")),
                                                m('.col-md-6', m('label.col-form-label', profile.userName))

                                            )
                                        ),
                                        m('hr.hr-no-style'),
                                        m('.row',
                                            m('.form-group.row',
                                                m('label.col-md-4.col-form-label', this.getText("LT00000188", "Country")),
                                                m('.col-md-6', m('label.col-form-label', profile.countryName)),

                                            )
                                        ),
                                        m('hr.hr-no-style'),
                                        m('.row',
                                            m('.form-group.row',
                                                m('label.col-md-4.col-form-label', this.getText("LT00000189", "Knox ID")),
                                                m('.col-md-6', m('label.col-form-label', profile.singleID))
                                            )
                                        ),
                                        m('hr.hr-no-style'),
                                        m('.row',
                                            m('.form-group.row',
                                                m('label.col-md-4.col-form-label', this.getText("LT00000190", "Email")),
                                                m('.col-md-6', m('label.col-form-label', profile.email)),
                                            )
                                        ),
                                        m('hr.hr-no-style'),
                                        m('.row',
                                            m('.form-group.row',
                                                m('label.col-md-4.col-form-label', this.getText("LT00000191", "Mobile Number")),
                                                m('.col-md-6', m('label.col-form-label', profile.mobileNumber))
                                            )
                                        ),
                                        m('hr.hr-no-style'),
                                        m('.row',
                                            m('.form-group.row',
                                                m('label.col-md-4.col-form-label', this.getText("LT00000060", "User Role")),
                                                m('.col-md-6', m('label.col-form-label', profile.userRoleName)),
                                            )
                                        ),
                                        m('hr.hr-no-style'),
                                        m('.row',
                                            m('.form-group.row',
                                                m('label.col-md-4.col-form-label', this.getText("LT00000192", "Sales Force Type")),
                                                m('.col-md-6', m('label.col-form-label', profile.salesForceTypeName))
                                            )
                                        ),
                                        m('hr.hr-no-style'),
                                        m('.row',
                                            m('.form-group.row',
                                                m('label.col-md-4.col-form-label', this.getText("LT00000193", "User Type")),
                                                m('.col-md-6', m('label.col-form-label', profile.userTypeName)),
                                            )
                                        ),
                                        m('hr.hr-no-style'),
                                        m('.row',
                                            m('.form-group.row',
                                                m('label.col-md-4.col-form-label', this.getText("LT00000194", "Sales Force Rank Type")),
                                                m('.col-md-6', m('label.col-form-label', profile.salesForceRankTypeName))
                                            )
                                        ),
                                        m('hr.hr-no-style'),
                                        m('.row',
                                            m('.form-group.row',
                                                m('label.col-md-4.col-form-label', this.getText("LT00000195", "Language")),
                                                m('.col-md-6', m('label.col-form-label', profile.languageName)),
                                            )
                                        )
                                    )
                                )
                            )
                        ),

                    ),
                ),
                this.getBaseViews()
            ]
        }
    }
}
